import UploadMomModal from "./uploadMomModal";
export default UploadMomModal;